module.exports = __webpack_public_path__ + "img/yzs_dt_l_b.01e32265.gif";